// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"164":"be5a9cb4","594":"5a5a1466"}[chunkId] + ".chunk.css";
};